import {
  IconAnalytics,
  IconBell,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconShareGray,
  IconWarning,
} from '@assets/images/icon';
import { rtlsSystem3 } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailExhibition/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/retailExhibition/img/1.avif';
import image2 from '@src/assets/images/solution/retailExhibition/img/2.avif';
import image3 from '@src/assets/images/solution/retailExhibition/img/3.avif';
import image4 from '@src/assets/images/solution/retailExhibition/img/4.avif';
import image5 from '@src/assets/images/solution/retailExhibition/img/5.avif';

export default {
  type: '零售解决方案',

  banner: {
    title: '追踪观众位置，自动化作品讲解',
    desc: '通过佩戴的 UWB 标签实时追踪观众位置，当观众接近作品时，自动提供个性化讲解，提升参观体验。',
  },

  video: {
    title: '站在作品前，讲解自动开始',
    desc: '当观众靠近作品时，系统会自动播放该作品的介绍。无需人工讲解，观众可以随时了解作品详情，带来更沉浸、便捷的美术馆参观体验。',
    play: video,
  },

  func: [
    {
      theme: '根据观众位置自动提供作品讲解',
      title: '实时确认观众位置',
      desc: '通过佩戴的挂绳式 UWB 标签以 ±20cm 的高精度追踪观众位置。当观众接近作品时，系统会立即开始讲解。',
      sub1: '实时状态监测',
      icon1: IconClockGray,
      sub2: '快速数据联动',
      icon2: IconShareGray,
      video: subVideo1,
    },
    {
      title: '靠近作品时自动个性化讲解',
      desc: '观众走近某个作品时，系统会自动开始播放讲解，观众无需任何操作即可获得深入的信息。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '提供高精度',
      icon2: IconRulerGray,
      image: image1,
    },
    {
      title: '利用参观证分析移动轨迹',
      desc: '通过佩戴的参观证分析观众的移动轨迹和停留数据，掌握实际兴趣点，从而最大化展览策划与效果。',
      sub1: '提供高精度',
      icon1: IconRulerGray,
      sub2: '快速数据联动',
      icon2: IconChainLinkGray,
      image: image2,
    },
    {
      title: '进入危险区域即时提醒',
      desc: '当观众跨越围栏或进入限制区域时，系统会立即向管理员发送警报，通过实时监控预防安全事故。',
      sub1: '提供高精度',
      icon1: IconRulerGray,
      sub2: '快速数据联动',
      icon2: IconChainLinkGray,
      video: subVideo3,
    },
    {
      theme: '利用观众数据高效管理展览运营',
      title: '按作品自动分析关注度',
      desc: '通过热力图可视化观众停留最久的区域，直观分析空间占用率，明确了解最受欢迎的区域和作品。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '支持基于数据的内容策划',
      desc: '分析观众的移动轨迹和停留数据，实用性地应用于后续展览内容策划，最大化展览效果。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
    {
      title: '自动分析商店商品偏好度',
      desc: '分析纪念品店内观众停留时间和移动轨迹，客观衡量各商品的人气，优化商品陈列组合，提升销售额。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: '支持空间布局优化',
      desc: '基于观众密集度数据，实时优化工作人员分配，提高人员效率，降低运营成本。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image5,
    },
  ],

  subfunc: {
    title: '主要功能概览',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: '观众位置追踪',
        desc: '实时追踪佩戴参观证的观众位置。',
      },
      {
        icon: IconBell,
        title: '自动作品讲解',
        desc: '观众靠近作品时，自动播放个性化讲解音频。',
      },
      {
        icon: IconRoute,
        title: '移动轨迹记录',
        desc: '自动记录并分析观众的移动轨迹和作品停留时间。',
      },
      {
        icon: IconWarning,
        title: '危险区域接近提醒',
        desc: '当观众进入限制区域时，立即通知管理员。',
      },
      {
        icon: IconAnalytics,
        title: '作品关注度分析',
        desc: '通过热力图可视化停留位置和时间，分析作品关注度。',
      },
      {
        icon: IconPenSquare,
        title: '展览内容策划支持',
        desc: '分析观众数据，反映偏好，用于展览策划。',
      },
      {
        icon: IconSearch,
        title: '商店商品偏好度分析',
        desc: '分析商店内观众停留数据，掌握商品人气。',
      },
      {
        icon: IconDashboard,
        title: '实时人员配置优化',
        desc: '实时分析观众密集度，支持高效人员安排。',
      },
      {
        icon: IconLayers,
        title: '观众回访率测定',
        desc: '分析回访频率和行为模式，评估观众忠诚度。',
      },
      {
        icon: IconChartBar,
        title: '活动效果测定',
        desc: '自动收集活动前后观众数据，评估活动效果。',
      },
    ],
  },

  system: {
    title: '系统结构',
    img: rtlsSystem3,
  },

  productTitle: '产品组合',
  product: [
    {
      tag: 'peoplePackage',
    },
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'manufacturingAsset',
    },
    {
      data: 'logisticsSafety',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
